import {
  Card,
  CardContent,
  Box,
  Typography,
  Grid,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import { AttachMoney as MoneyIcon } from "@mui/icons-material";
import { useTranslation } from "react-i18next";
import { IServiceValue, isFieldDiff } from "../../../../../types/review";
import FieldDiff from "./FieldDiff";

interface ServicePricesDetailsProps {
  services: {
    [vehicleType: string]: {
      [serviceKey: string]: IServiceValue;
    };
  };
  title?: string;
}

const ServicePricesDetails = ({
  services,
  title,
}: ServicePricesDetailsProps) => {
  const { t } = useTranslation();

  const SERVICE_KEY_MAP: Record<string, string> = {
    inner: "innerWash",
    outer: "outerWash",
    both: "fullWash",
  };

  const formatVehicleType = (vehicleType: string) =>
    t(`settings.washingClass.${vehicleType}`, vehicleType);

  const formatServiceName = (serviceKey: string) => {
    const mappedKey = SERVICE_KEY_MAP[serviceKey] ?? serviceKey;
    return t(`settings.washingClass.${mappedKey}`, mappedKey);
  };

  return (
    <Grid size={12}>
      <Card variant="outlined">
        <CardContent>
          <Box display="flex" alignItems="center" mb={2}>
            <MoneyIcon sx={{ mr: 1 }} />
            <Typography variant="h6">{title ?? t("carWashDetails.servicePrices")}</Typography>
          </Box>
          {Object.entries(services).map(
            ([vehicleType, servicesList]: [string, any]) => (
              <Box key={vehicleType} mb={2}>
                <Typography variant="subtitle1" sx={{ mb: 1, fontWeight: 600 }}>
                  {formatVehicleType(vehicleType)}
                </Typography>
                <TableContainer>
                  <Table size="small">
                    <TableHead>
                      <TableRow>
                        <TableCell>{t("carWashDetails.serviceType")}</TableCell>
                        <TableCell align="right">{t("carWashDetails.price")}</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {Object.entries(servicesList).map(
                        ([serviceKey, price]) => (
                          <TableRow key={serviceKey}>
                            <TableCell>
                              {formatServiceName(serviceKey)}
                            </TableCell>
                            <TableCell align="right">
                              {isFieldDiff(price) ? (
                                <FieldDiff
                                  diff={price}
                                  formatValue={(val) => `₼ ${val}`}
                                />
                              ) : (
                                <>₼ {price}</>
                              )}
                            </TableCell>
                          </TableRow>
                        )
                      )}
                    </TableBody>
                  </Table>
                </TableContainer>
              </Box>
            )
          )}
        </CardContent>
      </Card>
    </Grid>
  );
};

export default ServicePricesDetails;
